/**
 * Cache ĐỒNG BỘ cho cờ Config:ThuTheoKyTatCaHocKyNamHoc.
 * Tách riêng (KHÔNG import apiClient/react) để reducer — chạy rất sớm lúc tạo store —
 * đọc được cờ mà không kéo theo apiClient vào chuỗi import (tránh vòng lặp import).
 * Hook useThuTatCaHocKyNamHoc fetch API rồi ghi vào đây; reducer chỉ đọc.
 */
const LS_KEY = "cfg_thu_tat_ca_hk_nh";

let cached: boolean | null = null;

const readLs = (): boolean => {
  try {
    return localStorage.getItem(LS_KEY) === "1";
  } catch {
    return false;
  }
};

/** Giá trị cache trong phiên (null = chưa fetch lần nào). */
export const getThuTatCaCachedRaw = (): boolean | null => cached;

/** Đọc cờ ĐỒNG BỘ: ưu tiên cache phiên, fallback localStorage (từ phiên trước). */
export const getThuTatCaHkNhSync = (): boolean => cached ?? readLs();

/** Hook gọi sau khi fetch xong: lưu cache phiên + localStorage cho lần sau. */
export const setThuTatCaCached = (v: boolean): void => {
  cached = v;
  try {
    localStorage.setItem(LS_KEY, v ? "1" : "0");
  } catch {
    /* ignore */
  }
};
